// import { ScrollTrigger } from "gsap/ScrollTrigger";
import Contacts from '../modules/blocks/contacts';
import Hero from '../modules/blocks/hero';
import Testimonials from '../modules/blocks/testimonials';
import Services from '../modules/blocks/services';
import Showcase from '../modules/blocks/showcase';
import GradientText from '../modules/blocks/gradientText';
import AccordionSection from "../modules/blocks/accordionSection";
import Cards from "../modules/blocks/cards";
import SingleVacancy from "../modules/blocks/singleVacancy";
import GradientImage from "../modules/blocks/gradientImage";
import HeroMap from "../modules/blocks/heroMap";
import Numbers from "../modules/blocks/numbers";

function entry() {
    new Hero('.hero');
    new Services('.services');
    new Testimonials('.testimonials');
    new Contacts('.contacts');
    new Showcase('.showcase');
    new GradientText('.gradient-text');
    new Cards('.cards');
    new SingleVacancy('.single-vacancy');
    new GradientImage('.gradient-image');
    new HeroMap('.hero-map');
    new Numbers('.numbers');
    new AccordionSection('.accordion');

    // requestAnimationFrame(() => {
    //     requestAnimationFrame(() => {
    //         ScrollTrigger.refresh();
    //     });
    // });

}

window.addEventListener('DOMContentLoaded', entry);